
export const clearApplicationData = () => {
    return {
        type: 'CLEAR_APPLICATION_DATA'
    }
}

export const resetApplicationData = () => {
    return {
        type: 'RESET_APPLICATION_DATA'
    }
}


export const updateApplicationData = (data) => {
    return {
        type: 'UPDATE_APPLICATION_DATA',
        data
    }
}


export const setApplicationData = (data) => {
    return {
        type: 'SET_APPLICATION_DATA',
        data
    }
}

export const setApplicationBids = (data) => {
    return {
        type: 'SET_APPLICATION_BIDS',
        data
    }
}

export const setApplicationProjectLead = (data) => {
    return {
        type: 'SET_APPLICATION_PROJECT_LEAD',
        data
    }
}


export const setApplicationIndicative = (data) => {
    return {
        type: 'SET_APPLICATION_INDICATIVE',
        data
    }
}

